import React from 'react';
import { observer } from 'mobx-react';
import CompanyCarousel from './components/CompanyCarousel';
import store from '../../../stores/store';
import CompanyPairing from './components/CompanyPairing';

const CompanyPanel = observer(
    class CompanyPanel extends React.Component {
        constructor() {
            super();

            if (typeof store.companies.data.Companies === 'undefined') {
                store.companies.fetch();
            }
        }

        renderHeader = () => {
            let arrowClass = 'toggle-arrow';

            if (!store.companies.collapsed) {
                arrowClass = 'toggle-arrow collapsed';
            }

            let companyName = store.companies.getNameByIndex();
            return (
                <div className="container-fluid mt-2">
                    <div className="row">
                        <div className="col pl-0">
                            <div
                                onClick={store.companies.togglePanel}
                                className={arrowClass}
                                id="companies-header-bar"
                                data-toggle="collapse"
                                aria-expanded={store.companies.collapsed}
                                aria-controls="collapseCompanyCarousel"
                            >
                                <h6>
                                    <span className="text-muted">Companies</span>
                                </h6>
                                {store.companies.selectedIndex !== null ? (
                                    <h6>
                                        <span className="text-muted carousel-breadcrumb">
                                            <b>{companyName ? ' / ' + companyName : ''}</b>
                                        </span>
                                    </h6>
                                ) : null}
                            </div>
                        </div>
                        <CompanyPairing />
                    </div>
                </div>
            );
        };

        render() {
            return (
                <div>
                    {this.renderHeader()}

                    <div
                        className={`group-block ${store.companies.collapsed
                            ? 'collapsed-custom'
                            : 'expanded-custom'}`}
                        id="companyCarousel"
                    >
                        <CompanyCarousel />
                    </div>
                </div>
            );
        }
    },
);

export default CompanyPanel;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Company/CompanyPanel.js